/**
 * Timezone-safe utilities for date-only strings (YYYY-MM-DD).
 *
 * new Date("2025-05-15") is interpreted as UTC midnight, which shifts the
 * displayed calendar date for users west of UTC.  The helpers here avoid
 * that by constructing local-time Date objects from the string components.
 */

/**
 * Parse a date-only string ("YYYY-MM-DD") into a Date at local midnight,
 * preventing the UTC-interpretation shift that `new Date(str)` causes.
 */
export const parseDateOnly = (dateStr: string): Date => {
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
};

/**
 * Format an event date range for display (e.g. "May 15-18" or "May 30 - Jun 2").
 * Accepts the raw YYYY-MM-DD strings stored on events.
 */
export const formatDateRange = (startDate: string, endDate: string): string => {
  const start = parseDateOnly(startDate);
  const end = parseDateOnly(endDate);

  const startMonth = start.toLocaleDateString('en-US', { month: 'short' });
  const endMonth = end.toLocaleDateString('en-US', { month: 'short' });

  if (startMonth === endMonth) {
    return `${startMonth} ${start.getDate()}-${end.getDate()}`;
  }
  return `${startMonth} ${start.getDate()} - ${endMonth} ${end.getDate()}`;
};
